import {ReactElement} from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import {useAuth} from '../use-auth';
import {NotFoundPage} from '@common/ui/not-found-page/not-found-page';
import {Role} from '@common/auth/user';

interface Props {
    children?: ReactElement;
    permission?: string;
    requireLogin?: boolean;
}
export function AdminAuthRoute({
    children,
    permission,
    requireLogin = true,
}: Props) {
    const {isLoggedIn, user} = useAuth();
    console.log('user', user, isLoggedIn);

    // console.log('isLoggedIn', isLoggedIn);

    // const admin = user?.role == Role.ADMIN;

    if (requireLogin && !isLoggedIn) {
        // if (isLoggedIn) {
        //     return <NotFoundPage />;
        // }

        if (user?.role === 'admin') {
            return <Navigate to="/admin" replace />;
        }

        return <Navigate to="/login" replace />;
    }

    if (!user) {
        return <Navigate to="/" replace />;
    }
    return children || <Outlet />;
}
